export default "__VITE_ASSET__CeXgNhil__"